// extracted by mini-css-extract-plugin
export var dividerLine = "_6k-3";
export var itemImage = "_6k-9";
export var lightDivider = "_6k-4";
export var modalContent = "_6k-5";
export var modalContentCompact = "_6k-6";
export var productCard = "_6k-a";
export var productImage = "_6k-b";
export var productImageCompact = "_6k-7";
export var productImagePlaceholder = "_6k-c";
export var productImagePlaceholderCompact = "_6k-8";
export var progressBarBackground = "_6k-1";
export var progressBarContainer = "_6k-0";
export var progressBarFill = "_6k-2";